// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-dialog__body[data-v-03e5ba61]{-ms-flex-wrap:nowrap;flex-wrap:nowrap}.el-dialog__body .phone[data-v-03e5ba61]{margin:0 0 22px 0}.el-dialog__body .phone .phone-input[data-v-03e5ba61]{display:inline-block;width:50%;margin-right:20px}.el-dialog__body .phone .deleteButton[data-v-03e5ba61]{display:inline-block}.el-dialog__body .operation[data-v-03e5ba61]{display:-webkit-box;display:-ms-flexbox;display:flex;margin-left:82px}", ""]);
// Exports
module.exports = exports;
